
import '../App.sass';
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from 'uuid';

interface Properties {
  className?: string;
  accept?: string;
  onUpload?: (files: FileList) => void;
}

export const FileUpload = (properties: Properties) => {
  const { t } = useTranslation();
  const [forId] = useState(uuidv4());
  const [dragOver, setDragOver] = useState(false);
  const fileInput = useRef() as any;

  const handleDragOver = (e: any) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = (e: any) => {
    e.preventDefault();
    setDragOver(false);
  };

  const handleDrop = (e: any) => {
    e.preventDefault();

    setDragOver(false);

    console.log(e);

    if (e.dataTransfer.files && properties.onUpload) {
      console.log("Uploading");

      properties.onUpload(e.dataTransfer.files);
    }
  };

  const handleFileChange = (e: any) => {
    if (properties.onUpload) {
      properties.onUpload(e.target.files);
    }

    fileInput.current.value = null;
  };

  return <div className="fileUpload">
    <div
      className={`${properties.className || ''} dropZone ${dragOver ? "dragOver" : ""}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <div className='textM'>
        {t('fileUpload.dragFilesHere')}
      </div>
      <div className='marginTopL displayFlex justifyContentCenter'>
        <label htmlFor={forId} className="customFileInput">
          {t('fileUpload.selectFiles')}
        </label>
        <input
          ref={fileInput}
          style={{ width: '200px', height: '300px', border: 'none' }}
          id={forId}
          accept={properties.accept}
          type="file"
          onChange={handleFileChange}
        ></input>
      </div>
    </div>
  </div>;
};